/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGuid } from "../models/AjaxResponseOfGuid";
import type { AjaxResponseOfVehicleInternalControlObservationDto } from "../models/AjaxResponseOfVehicleInternalControlObservationDto";
import type { VehicleInternalControlObservationCreateDto } from "../models/VehicleInternalControlObservationCreateDto";
import type { VehicleInternalControlObservationUpdateDto } from "../models/VehicleInternalControlObservationUpdateDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleInternalObservationsAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfVehicleInternalControlObservationDto
   * @throws ApiError
   */
  public getByVehicleId({
    vehicleId,
  }: {
    vehicleId: string;
  }): CancelablePromise<AjaxResponseOfVehicleInternalControlObservationDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-internal-observation/{vehicleId}",
      path: {
        vehicleId: vehicleId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGuid
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: VehicleInternalControlObservationCreateDto;
  }): CancelablePromise<AjaxResponseOfGuid> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-internal-observation",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: VehicleInternalControlObservationUpdateDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/vehicle-internal-observation",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicle-internal-observation/{id}",
      path: {
        id: id,
      },
    });
  }
}
